import { getWSIProjectionSnapshot, wsiProjectionAdapter, } from './wsiProjectionAdapter';
export { DefaultWSIDataProvider } from './DefaultWSIDataProvider';
export { createDefaultWSIRenderPaths, createWSIRenderPathResolver, } from './WSIRenderPathResolver';
export const wsiProjection = {
    adapter: wsiProjectionAdapter,
    getSnapshot: getWSIProjectionSnapshot,
};
export { default } from './WSIViewport';
